<div nz-row [ngClass]="'home-second-header'">
  <div nz-col nzSpan="22" nzOffset="2" class="upload">
    <nz-spin [nzSpinning]="loadingPage">
      <div class="ant-statistic-title" style="margin-bottom: 20px">
        <h4 style="font-size: 26px; color: #800180 !important; text-align: left;">Cu abonamentul de <b>500 Ron</b> faci <b>analize
            nelimitate</b> timp
          de 1 an pentru oricare din firmele tale.<br />
          Vezi evoluția față de perioadele anterioare sau poți compara rezultatele celorlalte firme ale tale indiferent
          de numărul lor.
        </h4>
      </div>
      <div class="container" style="margin-top: 40px;">
        <div class="card-group">
          <div class="column promotie" style="padding: 0px 40px 40px;">
            <!-- Large Star Badge -->
            <div class="promo-badge">
              <div class="promo-badge-text">PROMOȚIE</div>
            </div>

            <!-- Main Price -->
            <div class="price-display">
              500 <span class="price-currency">RON</span>
            </div>

            <!-- Card Content -->
            <div class="card-content-main">
              <div class="white-line"></div>
              <div class="duration-text ">Abonament</div>
              <div class="white-line"></div>
              <div class="analize-text ">Perioadă de utilizare</div>
              <div class="duration-text ">1 AN</div>
              <div class="white-line"></div>
              <div class="analize-text ">Număr analize</div>
              <div class="duration-text ">Nelimitat</div>
            </div>

            <!-- Alternative Button Style -->
            <button class="button-alt" (click)="tranzactionTypeChanged('carda4')">
              Plată<br>card
            </button>
          </div>
        </div>
        <!-- Hidden: 500 RON / 12 analyses package -->
        <div class="card-group" *ngIf="false">
          <div class="column financial" style="padding: 0px 40px 40px;">
            <div class="price-display white">
              500 <span class="price-currency">RON</span>
            </div>

            <!-- Card Content -->
            <div class="card-content-main">
              <div class="white-line"></div>
              <div class="analize-text white">Perioadă de utilizare</div>
              <div class="duration-text white">Nelimitată</div>
              <div class="white-line"></div>
              <div class="analize-text white">Număr analize</div>
              <div class="duration-text white">12</div>
              <div class="white-line"></div>
              <div class="analize-text white">Pachet</div>
            </div>
            <button class="button-alt white" (click)="tranzactionTypeChanged('card12')">
              Plată<br>card
            </button>
          </div>
        </div>

        <div class="card-group">
          <div class="column legal" style="padding: 0px 40px 40px;">
            <div class="price-display white">
              100 <span class="price-currency">RON</span>
            </div>

            <!-- Card Content -->
            <div class="card-content-main">
              <div class="white-line"></div>
              <div class="duration-text white">Utilizare unică</div>
              <div class="white-line"></div>
              <div class="analize-text white">Perioadă de utilizare</div>
              <div class="duration-text white">Nelimitată</div>
              <div class="white-line"></div>
              <div class="analize-text white">Număr analize</div>
              <div class="duration-text white">1</div>
            </div>
            <button class="button-alt white" (click)="tranzactionTypeChanged('card')">
              Plată<br>card
            </button>
          </div>
        </div>

        <div class="card-group">
          <div class="column facility" style="padding: 0px 40px 40px;">
            <div class="price-display white">
              20 <span class="price-currency">EUR</span>
            </div>

            <!-- Card Content -->
            <div class="card-content-main">
              <div class="white-line"></div>
              <div class="duration-text white">Utilizare unică</div>
              <div class="white-line"></div>
              <div class="analize-text white">Perioadă de utilizare</div>
              <div class="duration-text white">Nelimitată</div>
              <div class="white-line"></div>
              <div class="analize-text white">Număr analize</div>
              <div class="duration-text white">1</div>
            </div>
            <button class="button-alt white" (click)="tranzactionTypeChanged('sms')">
              Plată<br>SMS
            </button>
          </div>
        </div>
      </div>

      <!-- TVA notice -->
      <div style="margin-top: 24px; text-align: center;">
        <div class="tva-notice">
          <i nz-icon nzType="info-circle" nzTheme="outline" style="margin-right: 8px; font-size: 20px;"></i>
          Prețurile afișate sunt fără TVA
        </div>
      </div>

      <!-- Benefits text -->
      <div class="benefits-card">
        <ul class="benefits-list">
          <li>Înțelegi cum stă firma ta indiferent dacă ești inginer sau absolvent de Litere.</li>
          <li>Fă o analiză și vezi câtă valoare îți aduce o informație structurată și bine explicată.</li>
          <li>Cu o simplă încărcare de balanță primești trei tipuri de rapoarte.</li>
          <li>Primești și acces implicit în meniul Comparații și Variații Perioade în care îți prezentăm valori și grafice ale evoluției firmei tale.</li>
        </ul>
      </div>


      <form #form action="{{ mobilpayData.url }}" method="post" *ngIf="mobilpayData.env_key && mobilpayData.data">
        <input type="hidden" name="env_key" [value]="mobilpayData.env_key" />
        <input type="hidden" name="data" [value]="mobilpayData.data" />
      </form>

      <div class="info-area">
        <div class="info-icon">
          <!-- <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i> -->
          <svg width="40px" height="40px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" version="1.1"
            xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Layer_2">
              <path
                d="M27.86,29.46L16.94,1.66c-0.1-0.27-0.31-0.49-0.58-0.59c-0.05-0.02-0.11-0.04-0.17-0.05   C16.13,1.01,16.07,1,16,1s-0.13,0.01-0.19,0.02c-0.06,0.01-0.12,0.03-0.17,0.05c-0.25,0.1-0.46,0.3-0.57,0.56l-0.01,0.03   L4.07,29.63C3.92,30,4.01,30.42,4.29,30.7C4.48,30.9,4.74,31,5,31c0.12,0,0.24-0.02,0.36-0.07L16,26.87l10.64,4.06   C26.76,30.98,26.88,31,27,31c0.01,0,0.01,0,0.02,0c0.55,0,1-0.45,1-1C28.02,29.8,27.96,29.62,27.86,29.46z"
                fill="#2197F3" />
              <g>
                <path
                  d="M28.02,30c0,0.55-0.45,1-1,1c-0.01,0-0.01,0-0.02,0c-0.12,0-0.24-0.02-0.36-0.07L16,26.87V1    c0.07,0,0.13,0.01,0.19,0.02c0.06,0.01,0.12,0.03,0.17,0.05c0.27,0.1,0.48,0.32,0.58,0.59l10.92,27.8    C27.96,29.62,28.02,29.8,28.02,30z"
                  fill="#16BCD4" />
              </g>
            </g>
            <g id="Layer_3" />
            <g id="Layer_4" />
            <g id="Layer_5" />
            <g id="Layer_6" />
            <g id="Layer_7" />
            <g id="Layer_8" />
            <g id="Layer_9" />
            <g id="Layer_10" />
            <g id="Layer_11" />
            <g id="Layer_12" />
            <g id="Layer_13" />
            <g id="Layer_14" />
            <g id="Layer_15" />
            <g id="Layer_16" />
            <g id="Layer_17" />
            <g id="Layer_18" />
            <g id="Layer_19" />
            <g id="Maps_11_" />
            <g id="Maps_10_" />
            <g id="Maps_9_" />
            <g id="Maps_8_" />
            <g id="Maps_7_" />
            <g id="Maps_6_" />
            <g id="Maps_5_" />
            <g id="Maps_4_" />
            <g id="Maps_3_" />
            <g id="Maps_2_" />
            <g id="Maps_1_" />
            <g id="Maps" />
          </svg>
        </div>
        <div class="info-content">
          <p style="color: #666699; font-size: 22px;">Factura aferentă plăţii cu cardul o găsești în contul tău din
            aplicația DoctorBusiness.ro.</p>
          <p style="color: #666699; font-size: 22px;">Poţi edita factura cu datele firmei tale pana cel tarziu patru
            zile de la data emiterii, în secțiunea
            "Facturi și Plăţi"</p>
          <p style="color: #666699; font-size: 22px;">Dacă plăteşti prin SMS, decontarea plăţii se face pe factura de la
            furnizorul tău de telefonie mobilă.</p>
        </div>
      </div>
    </nz-spin>

    <div class="container">
      <div class="card-desc">
        <img src="/assets/img/netopia_logo.png" style="height: 180px" />
      </div>
    </div>
  </div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 239" id="bg-shape-black-small">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M0,241V140.62s385.16,99.61,889.34-39.8S1920,7.19,1920,7.19V241"></path>
      </g>
    </g>
  </svg>
</div>
